import { match } from 'ts-pattern';

import { resolveUserErrorCode } from '@/entities/user';

type IdentityConfirmationErrorDisplay =
    | { surface: 'field'; message: string }
    | { surface: 'toast'; message: string };

export function resolveIdentityConfirmationError(
    error: unknown,
): IdentityConfirmationErrorDisplay | undefined {
    return match(resolveUserErrorCode(error))
        .with('IDENTITY_CONFIRMATION_REQUIRED', () => ({
            surface: 'field' as const,
            message: 'Your confirmation has expired. Enter your password again.',
        }))
        .with('INVALID_CURRENT_PASSWORD', () => ({
            surface: 'field' as const,
            message: 'Incorrect password',
        }))
        .with('RATE_LIMITED', () => ({
            surface: 'toast' as const,
            message: 'Too many attempts. Try again later',
        }))
        .otherwise(() => undefined);
}
